import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

// Fallback: send Bearer token if cookies get stripped (cross-site iframe)
api.interceptors.request.use((config) => {
  const t = typeof window !== "undefined" ? localStorage.getItem("doccare_token") : null;
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function formatApiError(err, fallback = "Something went wrong") {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (typeof d === "object" && d.msg) return d.msg;
  return fallback;
}
